












import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import { TaxCountry, TaxFormDraft, TaxpayerInfo } from "../../../types";
import { canadianProvinces, taxpayerInfoFields, usStateOptions } from "../taxFormConfig";

export default defineComponent({
  name: "TaxpayerInfoForm",
  components: { BaseForm },
  props: {
    draft: { type: Object as PropType<TaxFormDraft | null>, default: null },
  },
  setup(props, { emit }) {
    const values = ref<FormValues>({
      legalFirstName: "",
      legalMiddleName: "",
      legalLastName: "",
      businessName: "",
      addressLine1: "",
      addressLine2: "",
      zipCode: "",
      city: "",
      state: "",
      country: TaxCountry.USA,
      ...(props.draft?.taxpayerInfo ?? {}),
    });

    const fields = computed(() => taxpayerInfoFields(values.value.country as TaxCountry));

    watch(
      () => values.value.country as TaxCountry,
      country => {
        const options = country === TaxCountry.CANADA ? canadianProvinces : usStateOptions;
        if (!options.some(option => option.value === values.value.state)) {
          values.value = { ...values.value, state: "" };
        }
      }
    );

    // The validation observer reports valid until its providers register, so the
    // step is considered valid only when the required fields are also non-empty.
    const requiredFields = ["legalFirstName", "legalLastName", "addressLine1", "zipCode", "city", "state", "country"];
    const requiredFilled = computed(() => requiredFields.every(name => !!values.value[name]));
    const formValid = ref(true);
    const manualValidate = ref<() => Promise<void>>(async () => {});
    const emitValid = () => emit("setValid", formValid.value && requiredFilled.value);

    const onFormValidation = (valid: boolean) => {
      formValid.value = valid;
      emitValid();
    };

    watch(
      values,
      () => {
        emit("updateDraft", { taxpayerInfo: { ...values.value } as TaxpayerInfo });
        emitValid();
        manualValidate.value().then(emitValid);
      },
      { immediate: true }
    );

    return { values, fields, manualValidate, onFormValidation };
  },
});
